import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center py-4"
}
const _hoisted_2 = {
  key: 1,
  class: "table-scrollbar mb-2"
}
const _hoisted_3 = { class: "table-header-row" }
const _hoisted_4 = { class: "table-edge-left" }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-right table-edge-right" }
const _hoisted_9 = { class: "table-edge-left" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "meter-cell text-right" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-center editing-meter-input"
}
const _hoisted_13 = {
  key: 1,
  class: "d-inline-flex align-items-center"
}
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right table-edge-right" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { colspan: "7" }

import { ref, computed, watch, nextTick } from 'vue';
import PaginateWithCount from '@/components/PaginateWithCount.vue';
import CopyElement from '@/components/CopyElement.vue';
import MileageCorrectionService from '@/services/models/MileageCorrectionService';
import i18n from '@/lang/i18n';
import type DeliveryPlan from '@/types/DeliveryPlan';


export default /*@__PURE__*/_defineComponent({
  __name: 'MileageCorrectionTable',
  props: {
    trips: {},
    loading: { type: Boolean },
    totalPage: {},
    itemsPerPage: {},
    allElementsCount: {},
    currentPage: {},
    correctionBaseId: {},
    correctionOutOfServiceMeter: {}
  },
  emits: ["update:currentPage", "update:correctionBaseId", "update:correctionOutOfServiceMeter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const editingId = ref<string | null>(null);
const editingOutOfServiceMeter = ref<string>('');
const editingError = ref<string>('');

const currentPageModel = computed({
  get: () => props.currentPage,
  set: (value) => emit('update:currentPage', value),
});

const tripsSortedByLeavingTime = computed(() =>
  [...props.trips].sort(
    (a, b) =>
      new Date(a.leaving_warehouse_date_time).getTime() -
      new Date(b.leaving_warehouse_date_time).getTime()
  )
);

// Map<delivery_plan_id, 修正後出庫時メーター(km)>
const correctedMeters = computed<Map<string, number>>(() => {
  if (props.correctionBaseId === null || props.correctionOutOfServiceMeter === null) {
    return new Map();
  }

  const sorted = tripsSortedByLeavingTime.value;
  const baseIndex = sorted.findIndex(op => op.delivery_plan_id === props.correctionBaseId);
  if (baseIndex === -1) {
    return new Map();
  }

  const result = new Map<string, number>();
  let runningOutOfServiceMeter = props.correctionOutOfServiceMeter;

  for (let i = baseIndex; i < sorted.length; i++) {
    result.set(sorted[i].delivery_plan_id, runningOutOfServiceMeter);
    runningOutOfServiceMeter = Math.round((runningOutOfServiceMeter + Number(sorted[i].total_mileage ?? 0)) * 10) / 10;
  }

  return result;
});

function isCorrected(item: DeliveryPlan): boolean {
  return MileageCorrectionService.isCorrected(item, correctedMeters.value);
}

function getPrevReturnMeter(item: DeliveryPlan): number | null {
  return MileageCorrectionService.getPrevReturnMeter(item, tripsSortedByLeavingTime.value, correctedMeters.value);
}

function applyPrevReturnMeter(item: DeliveryPlan) {
  const value = getPrevReturnMeter(item);
  if (value === null) {
    return;
  }
  emit('update:correctionBaseId', item.delivery_plan_id);
  emit('update:correctionOutOfServiceMeter', value);
}

function startEditing(item: DeliveryPlan) {
  editingId.value = item.delivery_plan_id;
  const preset = props.correctionBaseId === item.delivery_plan_id && props.correctionOutOfServiceMeter !== null
    ? props.correctionOutOfServiceMeter
    : item.out_of_service_meter;
  editingOutOfServiceMeter.value = preset != null ? String(preset) : '';

  nextTick(() => {
    const input = document.querySelector<HTMLInputElement>('.editing-meter-input input');
    input?.focus();
    input?.select();
  });
}

function confirmEditing() {
  if (editingId.value === null) {
    return;
  }
  const error = MileageCorrectionService.validateOutOfServiceMeter(editingOutOfServiceMeter.value);
  if (error) {
    editingError.value = error;
    return;
  }
  emit('update:correctionBaseId', editingId.value);
  emit('update:correctionOutOfServiceMeter', parseFloat(editingOutOfServiceMeter.value));
  resetEditing();
}

function resetEditing() {
  editingId.value = null;
  editingOutOfServiceMeter.value = '';
  editingError.value = '';
}

watch(() => props.trips, resetEditing);

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_3, [
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.tripId')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.leavingDatetime')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.returningDatetime')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.outOfServiceMeter')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.totalMileage')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.returnMeter')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.diff')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (props.trips.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.trips, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.delivery_plan_id,
                        class: _normalizeClass({
              'correction-base-row': props.correctionBaseId === item.delivery_plan_id,
              'correction-affected-row': isCorrected(item) && props.correctionBaseId !== item.delivery_plan_id,
            })
                      }, [
                        _createElementVNode("td", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(item.delivery_plan_id.slice(-7)), 1),
                            _createVNode(CopyElement, {
                              copyText: item.delivery_plan_id,
                              size: "small",
                              class: "ml-1"
                            }, null, 8, ["copyText"])
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_unref(MileageCorrectionService).toDateTime(item.leaving_warehouse_date_time)), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(MileageCorrectionService).toDateTime(item.returning_warehouse_date_time)), 1),
                        _createElementVNode("td", _hoisted_11, [
                          (editingId.value === item.delivery_plan_id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_v_text_field, {
                                  modelValue: editingOutOfServiceMeter.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editingOutOfServiceMeter).value = $event)),
                                  type: "number",
                                  density: "compact",
                                  "hide-details": !editingError.value,
                                  "error-messages": editingError.value,
                                  suffix: "km",
                                  class: "meter-input",
                                  onKeydown: [
                                    _withKeys(confirmEditing, ["enter"]),
                                    _withKeys(resetEditing, ["esc"])
                                  ]
                                }, null, 8, ["modelValue", "hide-details", "error-messages"]),
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "text",
                                  icon: "mdi-check",
                                  color: "success",
                                  class: "ml-1",
                                  onClick: confirmEditing
                                }),
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "text",
                                  icon: "mdi-close",
                                  class: "ml-1",
                                  onClick: resetEditing
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["meter-value", { 'corrected-base-value': isCorrected(item) }])
                                }, _toDisplayString(_unref(MileageCorrectionService).displayOutOfServiceMeter(item, correctedMeters.value)), 3),
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "text",
                                  icon: "mdi-pencil",
                                  onClick: ($event: any) => (startEditing(item))
                                }, null, 8, ["onClick"]),
                                (getPrevReturnMeter(item) !== null)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      size: "x-small",
                                      variant: "text",
                                      icon: "mdi-auto-fix",
                                      color: "primary",
                                      title: _unref(i18n).global.t('pages.mileageCorrection.applyPrevBtn'),
                                      onClick: ($event: any) => (applyPrevReturnMeter(item))
                                    }, null, 8, ["title", "onClick"]))
                                  : _createCommentVNode("", true)
                              ]))
                        ]),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(MileageCorrectionService).displayTotalMileage(item)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass(["text-right", { 'corrected-base-value': isCorrected(item) }])
                        }, _toDisplayString(_unref(MileageCorrectionService).displayReturnMeter(item, correctedMeters.value)), 3),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ 'corrected-value': isCorrected(item) })
                          }, _toDisplayString(_unref(MileageCorrectionService).getDiff(item, correctedMeters.value, tripsSortedByLeavingTime.value)), 3)
                        ])
                      ], 2))
                    }), 128))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(i18n).global.t('pages.mileageCorrection.noData')), 1)
                    ]))
              ])
            ]),
            _: 1
          })
        ])),
    _createVNode(PaginateWithCount, {
      class: "justify-end",
      totalPage: props.totalPage,
      modelValue: currentPageModel.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPageModel).value = $event)),
      itemsPerPage: props.itemsPerPage,
      allElementsCount: props.allElementsCount,
      showItemCount: true
    }, null, 8, ["totalPage", "modelValue", "itemsPerPage", "allElementsCount"])
  ], 64))
}
}

})